import { Typography } from '@mui/material'
import { Testable, WithStyle } from '@eventops/chronotrack-ctlive-mui'
import { useTeamEntries } from '../../features/checkin/hooks/useTeamEntries'
import { useTeam } from '../../features/checkin/hooks/useTeam'
import { CheckinEntry } from '../../app/types'

export type BibProps = {
  data: CheckinEntry
} & WithStyle & Testable

export function isRelaySharedBibTeam(team: CheckinEntry) {
  return team.teamShareBib && team.teamType === 'RELAY'
}

export function renderBib(team: CheckinEntry | undefined, selectedEntry: CheckinEntry) {
  return team && isRelaySharedBibTeam(team) ? team.bib : selectedEntry.bib
}

export const Bib = (props: BibProps) => {
  const {
    className,
    style,
    data
  } = props

  const teamEntries = useTeamEntries(data)
  const team = useTeam(teamEntries)

  return (
    <Typography
      data-cy={props['data-cy']}
      className={className}
      style={style}
    >
      {renderBib(team, data)}
    </Typography>
  )
}

export default Bib
